import links from "./links"

export const headerDesktopLinksShort = [
  {
    ...links.FEATURES,
    type: "FEATURES",
    href: undefined,
  },
  {
    ...links.USE_CASES,
    type: "USE_CASES",
    href: undefined,
  },
  {
    ...links.RESOURCES,
    type: "RESOURCES",
    href: undefined,
  },
  {
    type: "PRICING",
    ...links.PRICING,
  },
]
